




















import {
  defineComponent, useContext, useFetch, ref, computed, useRoute, onMounted,
} from '@nuxtjs/composition-api';
import SfBreadcrumbs from '/storefrontUI/components/components/atoms/SfBreadcrumbs/SfBreadcrumbs.vue';
import {CmsPage, useContent, useUiHelpers} from '~/composables';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import { Breadcrumb } from '~/modules/catalog/types';
import {usePageStore} from "~/stores/page";
import {isFilterEnabled} from "~/modules/catalog/category/config/FiltersConfig";
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

export default defineComponent({
  components: { SfBreadcrumbs,  SkeletonLoader, },
  setup() {
    const route = useRoute();
    const { routeData } = usePageStore();
    const { getCatLink } = useUiHelpers();
    const { localePath } = useContext();
    const page = ref<CmsPage | null>(null);
    const {
      loadPage,
      loading,
      error,
    } = useContent();

    let url = route.value.path.split('/');

    const {
      activeCategory, categoryAncestors, isCategoryTreeLoaded, loadCategoryTree,
    } = useTraverseCategory();
    const breadcrumbs = ref<Breadcrumb[]>([]);

    const activeCategoryName = computed(() => activeCategory.value?.name ?? '');

    useFetch(async () => {
      if (!isCategoryTreeLoaded.value) {
        await loadCategoryTree();
      }


      breadcrumbs.value = categoryAncestors.value.slice(0, -1).map((category) => ({
        text: category.name,
        link: localePath(getCatLink(category)),
      }));

      if(categoryAncestors.value.length != 0) {
        let category = {
          "text": activeCategoryName.value,
          "link": '',
        }

        breadcrumbs.value.push(category);
      }
      else {
        let brand = {
          "text": 'Brand',
          "link": '/'+url[1]+'/'+url[2],
        }

        breadcrumbs.value.push(brand);

        page.value = await loadPage({ identifier: routeData.identifier });
        let brandName = {
          "text": page.value.title,
          "link": '',
        }

        breadcrumbs.value.push(brandName);
      }
    });

    const isLoading = ref(true);

    onMounted(async () => {
      isLoading.value = false;
    });

    return {
      breadcrumbs,
      isLoading,
    };
  },
});
